import { px } from 'csx';
import { calcTrendCardWidth } from 'src/components/TrendCard/TrendCard';
import { media, style } from 'typestyle';

export const quickTrendsStyles = (isPrintMode: boolean, numCardsLarge: number = 2) => ({
  root: style({
    $debugName: 'quicktrends-root',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }),
  container: style({
    $debugName: 'quicktrends-container',
    display: 'flex',
    height: '100%',
  }),
  summary: style(
    // 1 card width for small screens, 2 for larger screens
    media(
      { maxWidth: 1672 },
      {
        $debugName: 'quicktrends-summary-container',
        width: `calc(${px(calcTrendCardWidth() * 1)} + 2rem)`,
      },
    ),
    {
      $debugName: 'quicktrends-summary-container',
      width: `calc(${px(calcTrendCardWidth() * (isPrintMode ? 1 : numCardsLarge))} + 2rem)`,
    },
  ),
  details: style({
    $debugName: 'quicktrends-details-container',
    height: '100%',
    padding: '0 1rem 0 0',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  }),
});
